let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("MrUJ0"), load("e08m0"), load("hXFaG"), load("5hFEw"), load("7Q0UC"), load("6vOHT")]).then(() => parcelRequire('diitp'));